module.exports = __webpack_public_path__ + "img/2.1277b13a.png";